import apiKeysService from "../../../apis/services/admin/apiKeysService";
import {
  FETCH_API_KEYS_ATTEMPT,
  FETCH_API_KEYS_SUCCESS,
  FETCH_API_KEYS_ERROR,
  FETCH_API_KEYS_RESET_STATE,
  CREATE_API_KEY_ATTEMPT,
  CREATE_API_KEY_SUCCESS,
  CREATE_API_KEY_ERROR,
  CREATE_API_KEY_RESET_STATE,
  UPDATE_API_KEY_ATTEMPT,
  UPDATE_API_KEY_SUCCESS,
  UPDATE_API_KEY_ERROR,
  UPDATE_API_KEY_RESET_STATE,
  DELETE_API_KEY_ATTEMPT,
  DELETE_API_KEY_SUCCESS,
  DELETE_API_KEY_ERROR,
  DELETE_API_KEY_RESET_STATE,
} from "../../actionTypes/actionTypes";

export const fetchApiKeys = (page = 1, perPage = 10, term = "", sortBy = "id", order = "DESC") => {
  return async (dispatch) => {
    dispatch({ type: FETCH_API_KEYS_ATTEMPT });
    try {
      const response = await apiKeysService.fetchApiKeys(page, perPage, term, sortBy, order);
      dispatch({
        type: FETCH_API_KEYS_SUCCESS,
        payload: {
          data: response.data.data.rows,
          page: response.data.data.page,
          perPage: response.data.data.perPage,
          total: response.data.data.count,
        },
      });
    } catch (error) {
      dispatch({
        type: FETCH_API_KEYS_ERROR,
        payload: error,
      });
    }
  };
};

export const createApiKey = (name, description, applicationId) => {
  return async (dispatch) => {
    dispatch({ type: CREATE_API_KEY_ATTEMPT });
    try {
      const response = await apiKeysService.createApiKey(name, description, applicationId);
      dispatch({
        type: CREATE_API_KEY_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: CREATE_API_KEY_ERROR,
        payload: error,
      });
    }
  };
};

export const updateApiKey = (id, name, description, applicationId, active) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_API_KEY_ATTEMPT });
    try {
      const response = await apiKeysService.updateApiKey(id, name, description, applicationId, active);
      dispatch({
        type: UPDATE_API_KEY_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: UPDATE_API_KEY_ERROR,
        payload: error,
      });
    }
  };
};

export const deleteApiKey = (id) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_API_KEY_ATTEMPT });
    try {
      await apiKeysService.deleteApiKey(id);
      dispatch({
        type: DELETE_API_KEY_SUCCESS,
        payload: { id },
      });
    } catch (error) {
      dispatch({
        type: DELETE_API_KEY_ERROR,
        payload: error,
      });
    }
  };
};

export const fetchApiKeysResetState = () => {
  return (dispatch) => {
    dispatch({ type: FETCH_API_KEYS_RESET_STATE });
  };
};

export const createApiKeyResetState = () => {
  return (dispatch) => {
    dispatch({ type: CREATE_API_KEY_RESET_STATE });
  };
};

export const updateApiKeyResetState = () => {
  return (dispatch) => {
    dispatch({ type: UPDATE_API_KEY_RESET_STATE });
  };
};

export const deleteApiKeyResetState = () => {
  return (dispatch) => {
    dispatch({ type: DELETE_API_KEY_RESET_STATE });
  };
};


